<template>
  <div
    v-if="canInvite"
    data-component-group="business-users-dialog"
    data-component="invite-member"
  >
    <dialog-add
      icon="person_add"
      :title="$t('invite_member')"
      is-fullscreen
      :is-on="true"
      :close-icon="false"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-business-users-invite-member
          :is-on="true"
          :is-loading="isSendingInvite"
          :on-cancel="onCancel"
          :on-submit="sendInvite"
        />
      </template>
    </dialog-add>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isSendingInvite: false,
      };
    },
    computed: {
      canInvite() {
        return this.$store.getters['auth/isAuthorized']([{ subject: 'user', actions: ['invite'] }]);
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'business-users' });
      },
      sendInvite(user) {
        const query = { user };
        this.isSendingInvite = true;

        return this.$store
          .dispatch('businessUsers/inviteUser', query)
          .then((res) => {
            this.$router.push({ name: 'business-users', query: { status: 'success' } });
            return res;
          })
          .catch((err) => {
            return err;
          })
          .finally(() => {
            this.isSendingInvite = false;
          });
      },
    },
  };
</script>
